import Header from './components/layouts/Header/NavBar/NavBar';
import { Home } from './screens/Home/Home';

function App() {
    return (
        <>
            <Header />
            <Home />
        </>
    );
}

export default App;
